export default __webpack_public_path__ + "static/media/WeJoy.fe0dbd7e.png";